import EmptyBack from 'assets/images/noImage/background store 4.svg';

import AuctionCard from 'components/cards/auction';
import NewAdCard from 'components/cards/newAd';
import PrepaymentCard from 'components/cards/prepayment';
import SaleCard from 'components/cards/sale';
import {timeFromCreated} from 'utilities/helper/timeFromCreated';

export const convertorRplyCardType: Record<
  string,
  (post: UserMessagesMarketPost) => JSX.Element
> = {
  auction: post => {
    return (
      <AuctionCard
        wrapperClassName="!w-full"
        title={post.detail?.post_detail?.title || ''}
        image={
          post.detail?.post_detail?.main_image
            ? post.detail.post_detail.main_image.image
            : EmptyBack
        }
        createdDate={timeFromCreated(
          post.detail?.post_detail?.created_at || '',
        )}
        proposal={
          post.detail.post_detail?.sale?.realtime_price
            ? post.detail.post_detail?.sale?.realtime_price
            : 0
        }
        soldTime={
          post.detail.post_detail?.sale?.expire_date
            ? post.detail.post_detail?.sale?.expire_date
            : ''
        }
      />
    );
  },
  sale: post => {
    return (
      <SaleCard
        wrapperClassName="!w-full"
        title={post.detail.post_detail?.title || ''}
        image={
          post.detail.post_detail?.main_image
            ? post.detail.post_detail.main_image.image
            : EmptyBack
        }
        createdDate={timeFromCreated(post.detail.post_detail?.created_at || '')}
        price={
          post?.detail.post_detail?.price ? post?.detail.post_detail.price : 0
        }
        soldTime={
          post.detail.post_detail?.sale?.expire_date
            ? post.detail.post_detail?.sale?.expire_date
            : ''
        }
      />
    );
  },
  prepayment: post => {
    return (
      <PrepaymentCard
        size={
          post.detail.post_detail?.cultivation_area
            ? post.detail.post_detail.cultivation_area
            : 0
        }
        wrapperClassName="!w-full"
        title={post.detail.post_detail?.title || ''}
        image={
          post.detail.post_detail?.main_image
            ? post.detail.post_detail.main_image.image
            : EmptyBack
        }
        createdDate={timeFromCreated(post.detail.post_detail?.created_at || '')}
        price={
          post?.detail.post_detail?.price ? post?.detail.post_detail.price : 0
        }
        soldTime={
          post.detail.post_detail?.sale?.expire_date
            ? post.detail.post_detail?.sale?.expire_date
            : ''
        }
      />
    );
  },
  simple: post => {
    return (
      <NewAdCard
        wrapperClassName="!w-full"
        createdDate={timeFromCreated(post.detail.post_detail?.created_at || '')}
        image={
          post.detail.post_detail?.main_image
            ? post.detail.post_detail.main_image.image
            : EmptyBack
        }
        title={post.detail.post_detail?.title || ''}
        price={`${post.detail.post_detail?.price}`}
        state={
          post.detail.post_detail?.state ? post.detail.post_detail.state : ''
        }
        city={post.detail.post_detail?.city ? post.detail.post_detail.city : ''}
        degree={post.detail.post_detail?.grade}
      />
    );
  },
};
